import { ManageDiscountCategorySlabForm } from './ManageDiscountCategorySlabForm';

export interface ManageDiscountCategorySlabFormDefaultValues {
  fromAmount: string;
  toAmount: string;
  discountType: string;
  value: string;
  minValue?: string;
  maxValue?: string;
}

const ManageDiscountCategorySlabFormContainer = ({
  discountCategoryId,
  discountCategoryDetailId,
  defaultValues,
}: {
  discountCategoryId: string;
  discountCategoryDetailId?: string;
  defaultValues?: ManageDiscountCategorySlabFormDefaultValues;
}) => {
  const formDefaultValues = {
    fromAmount: String(defaultValues?.fromAmount ?? ''),

    toAmount: String(defaultValues?.toAmount ?? ''),

    discountType: String(defaultValues?.discountType ?? ''),

    value: String(defaultValues?.value ?? ''),

    minValue: String(defaultValues?.minValue ?? ''),

    maxValue: String(defaultValues?.maxValue ?? ''),
  };

  return (
    <ManageDiscountCategorySlabForm
      discountCategoryId={discountCategoryId}
      discountCategoryDetailId={discountCategoryDetailId}
      defaultValues={formDefaultValues}
    />
  );
};

export default ManageDiscountCategorySlabFormContainer;
